import React from 'react';
import { ILabelValuePanel, ITrendPanel } from '../Dashboard.model';
import {
  SparkLineChart,
  SparkLineChartProps,
} from '@mui/x-charts/SparkLineChart';
import { areaElementClasses } from '@mui/x-charts/LineChart';
import { useTheme } from '@mui/material';
import { LayoutItem } from 'react-grid-layout';
import LabelValuePanel from '../LabelValuePanel/LabelValuePanel';

interface TrendPanelProps {
  panel: ITrendPanel;
  layout?: LayoutItem | undefined;
}
export default function TrendPanel(props: TrendPanelProps) {
  const { panel } = props;
  const theme = useTheme();
  const labelValuePanel: ILabelValuePanel = {
    ...panel,
    type: 'LABEL_VALUE',
    content: (
      <SparkLineChart
        area
        showHighlight
        showTooltip
        color={theme.palette.primary.main}
        sx={{
          maxWidth: '100%',
          maxHeight: '100%',
          [`& .${areaElementClasses.root}`]: {
            fill: `url(#area-gradient-${panel.id})`,
          },
        }}
        {...panel.sparkLineProps}
      >
        <AreaGradient id={`area-gradient-${panel.id}`} />
      </SparkLineChart>
    ),
  };

  return <LabelValuePanel panel={labelValuePanel} layout={props.layout} />;
}

export type StatCardProps = SparkLineChartProps<'line'> & {
  id: string;
};

function AreaGradient({ id }: { id: string }) {
  const theme = useTheme();
  return (
    <defs>
      <linearGradient id={id} x1="50%" y1="0%" x2="50%" y2="100%">
        <stop
          offset="0%"
          stopColor={theme.palette.primary.main}
          stopOpacity={0.3}
        />
        <stop
          offset="100%"
          stopColor={theme.palette.primary.main}
          stopOpacity={0}
        />
      </linearGradient>
    </defs>
  );
}

export function StatCard(props: StatCardProps) {}
